<template>
        <input type="text" class="w_full" :class="classObject" placeholder="휴대폰번호" ref="tf_phone"
            :value="value"
            @input="handleInput"
            @paste="handlePaste"
            @keydown.enter="action_Done()"
        >
</template>


<script>
import { formatPhoneHyphen } from '@/util/format-phone'
import { isValidPhone } from '@/util/validators'
import { mapState } from "vuex";

export default {
	props: {
		value: String,
		customClass: String,
	},
	data() {
		return {
			pastedValue: -1,
		};
	},
	watch: {
		value: function (newValue, oldValue) {
			if (this.isWindow) return;

			const newString = newValue ?? "";
			const oldString = oldValue ?? "";

			let cursorPosition = this.$refs.tf_phone.selectionStart;

			if (this.pastedValue > -1) {
				cursorPosition = this.pastedValue;
				if (newString[cursorPosition - 1] == "-") {
					cursorPosition -= 1;
				}
			} else if (newString.length - oldString.length > 1) {
				cursorPosition += newString.length - oldString.length - 1;
			}
			this.pastedValue = -1;

			this.$nextTick(() => {
				let target = this.$refs.tf_phone;
				target.setSelectionRange(cursorPosition, cursorPosition);
			});
		},
	},
	computed: {
		...mapState(["SaaS"]),

		isWindow: function () {
			return this.SaaS?.isWindow ?? false;
		},
		usingCustomClass: function () {
			return !(this.customClass == undefined || this.customClass == "");
		},
		classObject: function () {
			let object = {
				input_default: !this.usingCustomClass,
			};
			if (this.customClass != undefined && this.customClass != "") {
				object[this.customClass] = this.usingCustomClass;
			}
			return object;
		},
	},
	methods: {
		handleInput(e) {
			const input = e.target.value;
			const onlyNumbers = input.replace(/[^0-9]/g, "");

			if (this.isWindow) {
				const trimmed = onlyNumbers.slice(0, 15);
				this.$emit("input", new String(trimmed));
				return;
			}
			if (onlyNumbers.length < 12) {
				this.$emit("input", new String(formatPhoneHyphen(input)));
			} else {
				this.$emit("input", new String(this.value));
			}
		},
		handlePaste(e) {
			let pastedValue = e.clipboardData
				.getData("text/plain")
				.replace(/[^0-9]/g, "");
			let cursorPosition = this.$refs.tf_phone.selectionStart;
			this.pastedValue = cursorPosition + pastedValue.length;
		},
		action_Done() {
			if (this.value == "" || isValidPhone(this.value) == false) {
				return;
			}
			this.$emit("action_Done");
		},
	},
};
</script>


<style scoped>

</style>